import React, { useContext, useEffect, useState } from 'react';
import LoginIcon from '@mui/icons-material/Login';
import { Button } from '@mui/material';
import { useLocales } from '../locales';
import { AuthContext } from '../contexts';

const BackToMainUser = () => {
    const { t } = useLocales();

    const { tokenLogin } = useContext(AuthContext);
    const [hasPrimaryToken, setHasPrimaryToken] = useState(false);

    useEffect(() => {
        // Check if the 'primaryToken' exists in session storage
        const primaryToken = sessionStorage.getItem('primaryToken');
        setHasPrimaryToken(!!primaryToken); // Set to true if token exists, false otherwise
    }, []);

    const handleBackToMainUser = async () => {
        console.log('Logging back in as primary user');
        try {
            // Retrieve the primary token from session storage 
            const primaryToken = sessionStorage.getItem('primaryToken');

            if (primaryToken) {
                // Call tokenLogin to set the session with the primary token
                sessionStorage.removeItem('primaryToken');
                tokenLogin(primaryToken);
                console.log('Logged back in as primary user successfully');
            } else {
                console.error('Primary token not found in session storage');
            }
        } catch (error) {
            console.error('Error during login back to primary user:', error);
        }
    };

    // Conditionally render the button if the 'primaryToken' exists 
    if (!hasPrimaryToken) {
        return null; // Don't render anything if there's no primary token in session storage
    }

    return (
        <Button onClick={handleBackToMainUser} color='error' startIcon={<LoginIcon />}>{t("Back to main user")}</Button>
    );
};

export default BackToMainUser;
